import script from "./TestCreateCode.vue?vue&type=script&lang=ts&setup=true"
export * from "./TestCreateCode.vue?vue&type=script&lang=ts&setup=true"

import "./TestCreateCode.vue?vue&type=style&index=0&id=7dd48a21&lang=less"

const __exports__ = script;

export default __exports__